import { render, staticRenderFns } from "./IndustryMain.vue?vue&type=template&id=9fd731c2&"
import script from "./IndustryMain.vue?vue&type=script&lang=js&"
export * from "./IndustryMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports